<font style="font-weight:normal" *ngIf="playing()">{{eventResult.gross_to_par}}</font>
<font style="font-weight:normal" *ngIf="completed()">{{eventResult.total_score}}</font>
